/* eslint-disable camelcase */
import React, { Component, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import CryptoJS from 'crypto-js'
import ActionData from '../../types/ActionData'
import AuditVerificationType from '../../types/AuditVerification'
import Organization from '../../types/Organization'
import OrganizationDetail from '../../types/OrganizationDetail'
import Provider from '../../types/Provider'
import User from '../../types/User'
import RootState from '../../types/RootState'
import isAuthenticated from '../../routes/isAuthenticated'
import { Card, Container, Nav, Row, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import GeneralInfo from '../../components/Profile/GeneralInfo'
import FacilitiesList from '../../components/Profile/Facilities/FacilitiesList'
import LocationApplicationTable from './LocationApplicationTable'
import OrganizationClaims from './Claims/Organization'
import FacilityClaims from './Claims/Facility'
import OrganizationAuthorizations from './Authorizations/Organization'
import FacilityAuthorizations from './Authorizations/Facility'
import Rate from './Rate'
import CarePlan from './CarePlan'
import Audit from './Audit'
import AuditVerification from './AuditVerification'
import Detail from './Detail'
import SwitchFacilityModal from '../../components/Modals/SwitchFacilityModal'
import { setSelectedProvider, setOrganizationView, showOrganizationModal, addUserActivity } from '../../redux/actions/authentication'
import { updateProviderDetail } from '../../redux/actions/providerDetail'
import { getProviderAuditsAndVerifications } from '../../redux/actions/backgroundCheckVerification'
import { getProviderFileAudits, setProviderFileAudit } from '../../redux/actions/providerFileAudit'
import { replaceSpecialChars } from '../../utils/stringTools'
import { sortArrayOfObjects } from '../../utils/dataTools'
import { startCase } from 'lodash'
import './index.css'
import 'react-vertical-timeline-component/style.min.css'
import { clearCSVAuth } from '../../redux/actions/authorization'
import { clearCSVClaims } from '../../redux/actions/claims'
import { getLocationApplications } from '../../redux/actions/locationApplication'
import LocationApplicationType from '../../types/LocationApplicationType'
import LocationApplicationTruncated from '../../types/LocationApplicationTruncated'

interface Props {
  auditsAndVerifications: Array<AuditVerificationType>;
  locationApplications: Array<LocationApplicationTruncated>;
  addUserActivityResult: ActionData;
  height: number;
  details: Array<OrganizationDetail>;
  loadingDetails: boolean;
  organizationView: boolean;
  selectedProvider: Provider;
  user: User;
  userResult: ActionData;
  width: number;
  selectedOrganization: Organization;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string) => void;
  setSelectedProvider: (provider: Provider) => void;
  setOrganizationView: (organizationView: boolean) => void;
  setProviderFileAudit: (providerFileAuditId: number) => void;
  showOrganizationModal: (organizationModal: boolean) => void;
  getProviderFileAudits: (providerId: number, token: string) => void;
  getProviderAuditsAndVerifications: (providerId: number, token: string) => void;
  updateProviderDetail: (id: number, data: any, token: string) => void;
  clearCSVAuth: () => void;
  clearCSVClaims: () => void;
  getLocationApplications: (organizationId: number, eid: string, token: string) => void;
  onCloseLocationApplication?: (row: any, type: string) => void;
  onViewClosureDenialInformation?: (row: any, type: string) => void;
}

const generateProviderList = (
  providers: Array<Provider>
) => {
  return providers.map((provider) => ({ value: provider.provider_id + '', label: provider.provider_name }))
}


//   const { denialReason, documentCategories, providerLocationApplications } = useSelector((state: RootState) => ({
//     denialReason: state.denialReason.data,
//     documentCategories: state.documentCategory.data,
//     providerLocationApplications: state.locationApplication.locationApplications.data,
//   }))

class Profile extends Component<Props> {

  state = {
    key: '',
    showModal: false,
    provider: undefined,
    organizationId: -1,
    provider_id: -1,
    organization_id: -1,
    sortFacilities: 'a-z',
    selectedServiceCode: '',
    showFileAudit: false,
    locationApplications: [],
  }
  // const { denialReason, documentCategories, locationApplications, locationResources,   } = useSelector((state: RootState) => ({
  //   denialReason: state.denialReason.data,
  //   documentCategories: state.documentCategory.data,
  //   locationApplications: state.locationApplication.locationApplications.data,
  //   locationResources: state.locationApplications.resources.data,
  // }))

  componentDidMount() {
    const { selectedOrganization, selectedProvider, addUserActivity, setOrganizationView, getLocationApplications, user } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    let id
    let activity

    // Get the tab from URL parameters and handle the applications/application-list case
    const urlParams = new URLSearchParams(window.location.search);
    let tabFromUrl = urlParams.get('tab');



    if (user.role_id !== undefined) {
      if (user.role_id === 4) {
        this.setState({ key: tabFromUrl || 'authorizations' })
        setOrganizationView(false)
        activity = 'View Authorizations'
        id = { providerId: selectedProvider.provider_id }
      }
      else {
        this.setState({ key: tabFromUrl || 'facilities' })
        setOrganizationView(true)
        activity = 'View Facilities'
        id = { organizationId: selectedOrganization.organization_id }
        if (!user.isLakeland) {
          getLocationApplications(selectedOrganization.organization_id, email.eid, token)
        }
      }
    }
    const userActivity = {
      eid: email.eid,
      activity,
      ...id
    }
    addUserActivity(userActivity, token)
  }

  componentDidUpdate(prevProps: Props) {
    const { addUserActivityResult, user, organizationView, selectedOrganization, selectedProvider, addUserActivity, setOrganizationView, getLocationApplications } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    if (user !== prevProps.user) {
      if (user.role_id === 4) {
        this.setState({ key: 'authorizations' })
        setOrganizationView(false)
      }
      else {
        this.setState({ key: 'facilities' })
        setOrganizationView(true)
      }
    }

    if (organizationView !== prevProps.organizationView && !addUserActivityResult.loading) {
      const activity = organizationView ? 'View Facilities' : 'View Authorizations'
      const id = organizationView ? { organizationId: selectedOrganization.organization_id } : { providerId: selectedProvider.provider_id }

      const userActivity = {
        eid: email.eid,
        activity,
        ...id
      }
      addUserActivity(userActivity, token)
    }

    if (selectedOrganization !== prevProps.selectedOrganization && organizationView && organizationView === prevProps.organizationView && !addUserActivityResult.loading) {
      const userActivity = {
        eid: email.eid,
        activity: 'View Facilities',
        organizationId: selectedOrganization.organization_id
      }
      addUserActivity(userActivity, token)

      // Fetch location applications for the new organization
      if (!user.isLakeland && user.role == 'Admin') {
        getLocationApplications(selectedOrganization.organization_id, email.eid, token)
      }
    }

    if (selectedProvider !== prevProps.selectedProvider && !organizationView && organizationView === prevProps.organizationView && !addUserActivityResult.loading) {
      const userActivity = {
        eid: email.eid,
        activity: 'View Authorizations',
        providerId: selectedProvider.provider_id
      }
      addUserActivity(userActivity, token)
    }


  }

  closeModal = () => {
    this.setState({
      showModal: false,
      provider: undefined,
      provider_id: -1
    })
  }

  openModal = () => {
    this.setState({
      showModal: true
    })
  }

  handleOnChangeProvider = (selected: any) => {
    this.setState({ provider: selected, provider_id: parseInt(selected.value) })
  }

  handleUpdateSelectedProvider = () => {
    const { user, setSelectedProvider, getProviderAuditsAndVerifications, getProviderFileAudits } = this.props
    const { provider_id, key } = this.state

    if (user.provider_data !== undefined) {
      let selectedProvider = user.provider_data.find((providerList) => providerList.provider_id === provider_id)

      if (selectedProvider !== undefined) {
        const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

        setSelectedProvider(selectedProvider)
        getProviderFileAudits(selectedProvider.provider_id, token)
        getProviderAuditsAndVerifications(selectedProvider.provider_id, token)

        if (key === 'audits') {
          this.setState({ key: 'authorizations' })
        }

        this.setState({ showFileAudit: false })
      }
    }

    this.setState({
      showModal: false,
      provider: undefined,
      provider_id: -1
    })
  }

  handleSelectFacility = (event: any, provider: Provider) => {
    const { setSelectedProvider, setOrganizationView, getProviderAuditsAndVerifications, getProviderFileAudits } = this.props
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    setSelectedProvider(provider)
    getProviderFileAudits(provider.provider_id, token)
    getProviderAuditsAndVerifications(provider.provider_id, token)
    this.setState({ key: this.state.key === 'facilities' ? 'authorizations' : this.state.key })
    setOrganizationView(false)
  }

  handleSelectOrganization = () => {
    const { key } = this.state
    const { setOrganizationView } = this.props
    this.props.clearCSVAuth()
    this.props.clearCSVClaims()

    this.setState({
      key: key === 'authorizations' || key === 'rates' || key === 'audits-verifications' ? 'facilities' : this.state.key,
      showFileAudit: false
    })
    setOrganizationView(true)
  }

  handleSort = (selected: any) => {
    this.setState({ sortFacilities: selected.value })
  }

  handleSelectServiceCode = (serviceCode: string) => {
    this.setState({
      key: 'rates',
      selectedServiceCode: replaceSpecialChars(serviceCode)
    })
  }

  handleShowFileAudit = (id: number) => {
    const { selectedProvider, user, addUserActivity, setProviderFileAudit } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    this.setState({ showFileAudit: true })
    setProviderFileAudit(id)

    const userActivity = {
      eid: email.eid,
      activity: `View Provider File Audit ${id}`,
      providerId: selectedProvider.provider_id
    }
    addUserActivity(userActivity, token)
  }

  /**
   * Details functionality
   *  */

  handleSaveDetail = (providerDetailId: number, openings: number, providerId: number, error: any) => {
    const { user, updateProviderDetail } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    const data = { openings, providerId, eid: email.eid }
    if (!error) {
      updateProviderDetail(providerDetailId, data, token)
    }
  }

  handleTabChange = (key: string) => {
    const { user, organizationView, selectedOrganization, selectedProvider, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    const id = organizationView ? { organizationId: selectedOrganization.organization_id } : { providerId: selectedProvider.provider_id }

    this.setState({ key })

    const userActivity = {
      eid: email.eid,
      activity: `View ${startCase(key)}`,
      ...id
    }
    addUserActivity(userActivity, token)
  }

  render() {
    const { details, height, loadingDetails, organizationView, selectedOrganization, selectedProvider, user, width } = this.props
    const { key, provider, provider_id, selectedServiceCode, showModal, showFileAudit, sortFacilities } = this.state


    return (
      <Container
        style={{
          backgroundColor: '#fff',
          width: width,
          height: height - 20,
          maxWidth: width,
          overflow: 'hidden'
        }}>
        <Row className='row-header'>
          <div className='profile-header'>
            {organizationView ? (
              <div className='profile-header-txt'>
                <div className='profile-icon'>
                  <FontAwesomeIcon icon={['fas', 'university']} size='3x' />
                </div>
                <div>
                  <div className='profile-facility-container'>
                    <h4>{selectedOrganization.organization_name}</h4>
                    {
                      user.organization_data !== undefined && user.organization_data.length > 1 ? (
                        <span className='profile-switch-facility' onClick={() => { this.props.showOrganizationModal(true) }}>(switch organization)</span>
                      ) : (
                        <span></span>
                      )
                    }
                  </div>
                  <div className='profile-data'>
                    <div>Type: <span className='profile-bold'>Organization</span></div>
                    <div className='profile-item'>|</div>
                    <div className='profile-item'>Location: <span className='profile-bold'>{selectedOrganization.organization_city}, {selectedOrganization.organization_state}</span></div>
                    <div className='profile-item'>|</div>
                    <div className='profile-item'>Tax ID: <span className='profile-bold'>{selectedOrganization.organization_tax_id_number}</span></div>
                  </div>
                </div>
              </div>
            ) : (
              <div className='profile-header-txt'>
                <div className='profile-icon'>
                  <FontAwesomeIcon icon={['far', 'hospital']} size='3x' />
                </div>
                <div>
                  {this.props.user.role_id === 4 ? (
                    <div></div>
                  ) : (
                    <div>
                      <span className='profile-organization-txt' onClick={this.handleSelectOrganization}>{selectedOrganization.organization_name}</span> &gt;
                    </div>
                  )}
                  <div className='profile-facility-container'>
                    <h4>{selectedProvider.provider_name}</h4>
                    <span className='profile-switch-facility' onClick={this.openModal}>(switch facility)</span>
                  </div>
                  <div className='profile-data'>
                    <div>Tax ID: <span className='profile-bold'>{selectedProvider.tax_id_number}</span></div>
                    <div className='profile-item'>|</div>
                    <div className='profile-item'>Location ID: <span className='profile-bold'>{selectedProvider.evips_id}</span></div>
                    <div className='profile-item'>|</div>
                    <div className='profile-item'>Status:
                      {
                        selectedProvider.status === 'Active'
                          ? (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'green', color: 'white', width: 100, textAlign: 'center' }}>ACTIVE</span>)
                          : (selectedProvider.status === 'Pending'
                            ? (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'rgb(241, 194, 50)', color: 'white', width: 100, textAlign: 'center' }}>PENDING</span>)
                            : (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'red', color: 'white', width: 100, textAlign: 'center' }}>{selectedProvider.status !== undefined ? selectedProvider.status.toUpperCase() : ''}</span>))
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Row>
        <Row>
          <Tab.Container id='profile-tab' activeKey={key} onSelect={this.handleTabChange}>
            <Card style={{ border: 'none', width: width, height: height - 120 }}>
              <Card.Header>
                <Nav variant='tabs'>
                  {organizationView && (
                    <Nav.Item className='profile-nav-item'>
                      <Nav.Link eventKey='facilities'><b>Facilities</b></Nav.Link>
                    </Nav.Item>)
                  }
                  <Nav.Item className='profile-nav-item'>
                    <Nav.Link eventKey='authorizations'><b>Authorizations</b></Nav.Link>
                  </Nav.Item>
                  <Nav.Item className='profile-nav-item'>
                    <Nav.Link eventKey='claims'><b>Claims</b></Nav.Link>
                  </Nav.Item>
                  {organizationView && !user.isLakeland && (
                    <Nav.Item className='profile-nav-item'>
                      <Nav.Link eventKey='application-list'><b>Applications</b></Nav.Link>
                    </Nav.Item>
                  )}
                  <Nav.Item className='profile-nav-item'>
                    <Nav.Link eventKey='general-info'><b>General Info</b></Nav.Link>
                  </Nav.Item>
                  {!organizationView && (
                    <>
                      <Nav.Item className='profile-nav-item'>
                        <Nav.Link eventKey='rates'><b>Rates</b></Nav.Link>
                      </Nav.Item>
                      <Nav.Item className='profile-nav-item'>
                        <Nav.Link eventKey='audits-verifications'><b>Audits & Verifications</b></Nav.Link>
                      </Nav.Item>
                    </>
                  )}
                  {organizationView && (
                    <Nav.Item className='profile-nav-item'>
                      <Nav.Link eventKey='care-plan'><b>Care Plan</b></Nav.Link>
                    </Nav.Item>
                  )}
                  {
                    ((organizationView && user.isLakeland) || (organizationView && user.role === 'Admin') || (!organizationView && user.role === 'User')) && (details.length > 0) && (
                      <Nav.Item className='profile-nav-item'>
                        <Nav.Link eventKey='location-details'><b>Location Details</b></Nav.Link>
                      </Nav.Item>
                    )
                  }
                </Nav>
              </Card.Header>
              <Card.Body style={{ overflowY: 'auto' }}>
                <Tab.Content>
                  {organizationView && (
                    <Tab.Pane eventKey="facilities">
                      <FacilitiesList
                        height={height}
                        activeKey={key}
                        sortFacilities={sortFacilities}
                        facilities={user?.provider_data || []}
                        onChangeSort={this.handleSort}
                        onSelectFacility={this.handleSelectFacility}
                      />
                    </Tab.Pane>
                  )}
                  <Tab.Pane eventKey='authorizations'>
                    {
                      organizationView ? (
                        <OrganizationAuthorizations
                          height={height}
                          selectedProvider={selectedProvider}
                        />
                      ) : (
                        <FacilityAuthorizations
                          height={height}
                          selectedProvider={selectedProvider}
                          onSelectServiceCode={this.handleSelectServiceCode}
                        />
                      )
                    }
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey='applications'>
                    {
                      organizationView && (
                        <LocationApplicationTable
                          height={height}
                          selectedOrganization={undefined}
                          activeKey={''}
                          tabName={''} />
                      )
                    }
                  </Tab.Pane> */}
                  <Tab.Pane eventKey="application-list">
                    <div style={{ height: height, width: '100%' }}>
                      <LocationApplicationTable
                        height={height}
                        selectedOrganization={selectedOrganization}
                        tabName={''}
                        activeKey={key} />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey='general-info'>
                    <GeneralInfo
                      organizationView={organizationView}
                      provider={selectedProvider}
                      organization={selectedOrganization}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey='claims'>
                    {
                      organizationView ? (
                        <OrganizationClaims provider={selectedProvider} />
                      ) : (
                        <FacilityClaims provider={selectedProvider} />
                      )
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey='rates'>
                    {!organizationView && (
                      <Rate
                        height={height}
                        selectedServiceCode={selectedServiceCode}
                      />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey='care-plan'>
                    {organizationView && (
                      <CarePlan
                        height={height}
                      />
                    )}
                  </Tab.Pane>
                  {!organizationView && (
                    <Tab.Pane eventKey='audits-verifications'>
                      {
                        showFileAudit ? (
                          <Audit
                            height={height}
                            onReturnToAll={() => this.setState({ showFileAudit: false })}
                          />
                        ) : (
                          <AuditVerification
                            height={height}
                            onShowFileAudit={this.handleShowFileAudit}
                          />
                        )
                      }
                    </Tab.Pane>
                  )}
                  <Tab.Pane eventKey='location-details'>
                    {
                      ((organizationView && user.isLakeland) || (organizationView && user.role === 'Admin') || (!organizationView && user.role === 'User')) && (
                        <Detail
                          details={details}
                          height={height}
                          loading={loadingDetails}
                          organizationView={organizationView}
                          onSave={this.handleSaveDetail}
                        />
                      )
                    }
                  </Tab.Pane>
                </Tab.Content>
              </Card.Body>
            </Card>
          </Tab.Container>
        </Row>
        <SwitchFacilityModal
          disableButton={provider_id === -1}
          providerOptions={generateProviderList(user.provider_data !== undefined ? sortArrayOfObjects(user.provider_data, 'provider_name') : [])}
          selectedProvider={provider}
          show={showModal}
          onClose={this.closeModal}
          onChangeProviderData={this.handleOnChangeProvider}
          onClickSelect={this.handleUpdateSelectedProvider}
        />
      </Container>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  auditsAndVerifications: state.backgroundCheckVerification.all.data,
  addUserActivityResult: state.authentication.addUserActivity,
  details: state.providerDetail.providerDetails.data,
  loadingDetails: state.providerDetail.providerDetails.loading,
  organizationView: state.authentication.organizationView,
  selectedOrganization: state.authentication.selectedOrganization,
  selectedProvider: state.authentication.selectedProvider,
  user: state.authentication.user.data,
  userResult: state.authentication.user,
  selectedLocationApplication: state.authentication.selectedLocationApplication,// locationApplications: state.locationApplication.locationApplications
})

const mapDispatchToProps = (dispatch: any) => ({
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string) => dispatch(addUserActivity(data, token)),
  setSelectedProvider: (provider: Provider) => dispatch(setSelectedProvider(provider)),
  setOrganizationView: (organizationView: boolean) => dispatch(setOrganizationView(organizationView)),
  setProviderFileAudit: (providerFileAuditId: number) => dispatch(setProviderFileAudit(providerFileAuditId)),
  showOrganizationModal: (organizationModal: boolean) => dispatch(showOrganizationModal(organizationModal)),
  getProviderFileAudits: (providerId: number, token: string) => dispatch(getProviderFileAudits(providerId, token)),
  getProviderAuditsAndVerifications: (providerId: number, token: string) => dispatch(getProviderAuditsAndVerifications(providerId, token)),
  updateProviderDetail: (id: number, data: any, token: string) => dispatch(updateProviderDetail(id, data, token)),
  clearCSVAuth: () => dispatch(clearCSVAuth('LOCATION')),
  clearCSVClaims: () => dispatch(clearCSVClaims('LOCATION')),
  getLocationApplications: (organizationId: number, eid: string, token: string) => dispatch(getLocationApplications(organizationId, eid, token)),
})

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(Profile)
)

function dispatch(arg0: (dispatch: any) => void) {
  throw new Error('Function not implemented.')
}
